<template>
  <div class="look-detail">
    <div class="nav">
      <div class="nav-left">
        <div class="parallelogram-btn-left" @click="toMildew" :class="{'parallelogram-btn-active': lossType === 1}" style="margin-right: 0.5vw">
          <div>自然损耗</div>
        </div>
        <div class="parallelogram-btn-left" @click="toNatural" :class="{'parallelogram-btn-active': lossType === 2}" style="margin-right: 0.5vw">
          <div>霉变损耗</div>
        </div>
        <div class="parallelogram-btn-left" @click="toCrushed" :class="{'parallelogram-btn-active': lossType === 3}">
          <div>造碎损耗</div>
        </div>
      </div>
      <div class="nav-center"><div>{{title}}</div></div>
      <div class="nav-right">
        <div class="parallelogram-btn-right" @click="toPests" :class="{'parallelogram-btn-active': lossType === 4}" style="margin-right: 0.5vw">
          <div>虫害损耗</div>
        </div>
        <div class="parallelogram-btn-right" @click="tCarbide" :class="{'parallelogram-btn-active': lossType === 5}" style="margin-right: 0.5vw">
          <div>碳化损耗</div>
        </div>
        <div class="parallelogram-btn-right" @click="backPath">
          <div class="icon-font">&#xe612;</div>
          <div>返回</div>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="loss-main" v-if="hide">
        <div class="loss-main-select" style="justify-content: space-between;align-items: flex-end;margin-bottom: 0">
          <div class="loss-main-select-left">
            <div class="input-date-wrapper">
              <el-date-picker
                v-model="value"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="input-wrapper">
              <input placeholder="请输入批次号或烟叶简称"/>
            </div>
            <div class="query button">查询</div>
          </div>
          <div class="loss-main-operation-r">损耗统计：1800g</div>
        </div>
        <div class="detail">
          <div class="detail-box">
            <div class="detail-nav">
              <div class="plant-item" style="width: 5%">
                <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
              </div>
              <div class="plant-item" style="width: 5%">序号</div>
              <div class="plant-item" style="width: 10%">批次号</div>
              <div class="plant-item" style="width: 20%">烟叶简称</div>
              <div class="plant-item" style="width: 15%">仓库位置</div>
              <div class="plant-item" style="width: 10%">日期</div>
              <div class="plant-item" style="width: 10%">损耗原因</div>
              <div class="plant-item" style="width: 10%">损耗重量</div>
              <div class="plant-item" style="width: 10%">备注</div>
              <div class="plant-item" style="width: 10%">操作</div>
            </div>
            <div class="detail-content">
              <div class="detail-list-wrapper" v-for="(data,index) in sensorData" :key="index">
                <div class="plant-item" style="width: 5%">
                  <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data.id)"></div>
                </div>
                <div class="plant-item" style="width: 5%">{{index+1}}</div>
                <div class="plant-item" style="width: 10%">{{data.title}}</div>
                <div class="plant-item" style="width: 20%">{{data.name}}</div>
                <div class="plant-item" style="width: 15%">{{data.localAddress}}</div>
                <div class="plant-item" style="width: 10%">{{data.date}}</div>
                <div class="plant-item" style="width: 10%">{{title}}</div>
                <div class="plant-item" style="width: 10%">{{data.weight}}</div>
                <div class="plant-item" style="width: 10%"></div>
                <div class="plant-item" style="width: 10%">
                  <div class="detail-btn item-look" style="margin-right: 0.5vw" @click="toLookDetailView">查看</div>
                  <div class="detail-btn item-delete" @click="deleteSingle(data.id)">删除</div>
                </div>
              </div>
            </div>
            <div class="page-wrapper">
              <div class="page-wrapper-left">共57896条数据，每页显示8条，当前第1页</div>
              <div class="page-wrapper-right">
                <div class="page-btn">首页</div>
                <div class="page-btn">上一页</div>
                <div class="page-btn">下一页</div>
                <div class="page-btn">尾页</div>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="alert-box" v-if="show">
              <div class="alert-content">
                <div class="alert-content-title">删除提醒</div>
                <div class="alert-content-msg">是否确认删除选中数据?</div>
                <div class="alert-content-btn">
                  <div class="btn-cancel button" @click="cancelDelete">取消</div>
                  <div class="btn-confirm button" @click="confirmDelete">确认</div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'LossDetail',
  data () {
    return {
      lossType: '',
      title: '',
      hide: false,
      value: '',
      show: false,
      all: false,
      id: '',
      type: 0,
      idList: [],
      sensorData: [
        {title: 'A123', name: '福建省龙岩永定C3F-2012片烟', localAddress: '东肖仓库一号楼一楼一区', date: '2018-01-05', reason: '0', weight: '20g', sign: '0', id: '0'},
        {title: 'A123', name: '福建省龙岩永定C3F-2012片烟', localAddress: '东肖仓库一号楼一楼一区', date: '2018-01-05', reason: '0', weight: '20g', sign: '0', id: '1'},
        {title: 'A123', name: '福建省龙岩永定C3F-2012片烟', localAddress: '东肖仓库一号楼一楼一区', date: '2018-01-05', reason: '0', weight: '20g', sign: '0', id: '2'},
        {title: 'A123', name: '福建省龙岩永定C3F-2012片烟', localAddress: '东肖仓库一号楼一楼一区', date: '2018-01-05', reason: '0', weight: '20g', sign: '0', id: '3'},
        {title: 'A123', name: '福建省龙岩永定C3F-2012片烟', localAddress: '东肖仓库一号楼一楼一区', date: '2018-01-05', reason: '0', weight: '20g', sign: '0', id: '4'},
        {title: 'A123', name: '福建省龙岩永定C3F-2012片烟', localAddress: '东肖仓库一号楼一楼一区', date: '2018-01-05', reason: '0', weight: '20g', sign: '0', id: '5'},
        {title: 'A123', name: '福建省龙岩永定C3F-2012片烟', localAddress: '东肖仓库一号楼一楼一区', date: '2018-01-05', reason: '0', weight: '20g', sign: '0', id: '6'},
        {title: 'A123', name: '福建省龙岩永定C3F-2012片烟', localAddress: '东肖仓库一号楼一楼一区', date: '2018-01-05', reason: '0', weight: '20g', sign: '0', id: '7'}
      ]
    }
  },
  created () {
    let _this = this
    setInterval(function () {
      _this.hide = true
    }, 100)
    let lossType = this.$route.query.lossType
    console.log(lossType)
    _this.lossType = lossType
    this.getTitle(lossType)
  },
  watch: {
    '$route' () {
      this.getTitle(this.$route.query.lossType)
    }
  },
  methods: {
    selectAll: function () {
      this.type = 1
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.sensorData.map((data, index) => {
          data.sign = 1
          idList.push(data.id)
        })
        this.idList = idList
      } else {
        this.sensorData.map((data, index) => {
          data.sign = 0
          this.idList = []
        })
      }
    },
    selectSingle: function (id) {
      this.sensorData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data.id)
          } else {
            let idList = []
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.sensorData.length
    },
    deleteSingle: function (id) {
      this.show = true
      this.id = id
      this.type = 0
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
      console.log(this.idList)
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      let sensorData = []
      this.sensorData.map((data) => {
        if (this.type === 0) {
          if (data.id !== this.id) {
            sensorData.push(data)
          }
          this.sensorData = sensorData
        } else if (this.type === 1) {
          let sensorData = this.sensorData
          this.idList.map((data, index) => {
            this.sensorData.map((item, ind) => {
              if (data === item.id) {
                sensorData.splice(ind, 1)
              }
            })
          })
          this.sensorData = sensorData
          console.log(sensorData)
          this.all = false
          console.log('111')
        }
      })
      this.show = false
      this.id = ''
      this.idList = []
      this.$message({
        message: '删除成功!',
        type: 'success',
        center: 'true',
        duration: '1000'
      })
    },
    getTitle: function (lossType) {
      switch (lossType) {
        case 1:
          this.title = '霉变损耗'
          break
        case 2:
          this.title = '自然损耗'
          break
        case 3:
          this.title = '造碎损耗'
          break
        case 4:
          this.title = '虫害损耗'
          break
        case 5:
          this.title = '碳化损耗'
          break
      }
    },
    backPath: function () {
      this.$router.push({
        path: '/loss',
        query: {
          index: '9',
          lossType: this.lossType
        }
      })
    },
    toLookDetailView: function () {
      this.$router.push({
        path: '/loss/lookDetailView',
        query: {
          index: '9'
        }
      })
    },
    toLookDetailNew: function () {
      this.$router.push({
        path: '/loss/lookDetailNew',
        query: {
          index: '9'
        }
      })
    },
    toMildew: function () {
      this.lossType = 1
      this.goPath(this.lossType)
    },
    toNatural: function () {
      this.lossType = 2
      this.goPath(this.lossType)
    },
    toCrushed: function () {
      this.lossType = 3
      this.goPath(this.lossType)
    },
    toPests: function () {
      this.lossType = 4
      this.goPath(this.lossType)
    },
    tCarbide: function () {
      this.lossType = 5
      this.goPath(this.lossType)
    },
    goPath: function (lossType) {
      this.$router.push({
        path: '/loss/lossDetail',
        query: {
          index: '9',
          lossType: lossType
        }
      })
    }
  }
}
</script>

<style scoped>
  @import "Loss.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/loss/LossDetail.vue